import { useTranslation } from "react-i18next"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { CouponEntity } from "../../Objects/Coupon/CouponEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { DeleteRequest } from "../../services/ApiClientService"
import { useGetCoupon } from "./useGetCoupon"

export const useRemoveCoupon = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetCoupon } = useGetCoupon()

  const handleRemove = async (coupon: CouponEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.COUPON.DELETE}/${coupon.id}`)

      if (response.success) {
        await handleGetCoupon(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
